// 🔐 [Sécurité v13.69 P1 — Q4] Les fichiers téléversés (`/api/uploads/*`) exigent une connexion.
// Les balises <img>/<a> ne portent pas d'en-tête Authorization : on ajoute `?jwt=<jeton>` (même
// validation que le Bearer côté backend). Les URLs déjà signées (`?s=`) ou externes sont laissées telles quelles.
const API_URL = process.env.REACT_APP_BACKEND_URL;

export function jetonCourant() {
  return localStorage.getItem('auth_token') || sessionStorage.getItem('auth_token') || '';
}

export function urlFichier(url) {
  if (!url || typeof url !== 'string') return url;
  if (url.startsWith('data:') || url.startsWith('blob:')) return url;
  let complete = url;
  if (url.startsWith('/uploads/')) complete = `${API_URL}/api${url}`;
  else if (url.startsWith('/api/')) complete = `${API_URL}${url}`;
  if (!complete.includes('/api/uploads/') && !complete.includes('/api/lmds/confirmation-file/')) return complete;
  if (/[?&](s|jwt)=/.test(complete)) return complete;
  const jeton = jetonCourant();
  if (!jeton) return complete;
  return `${complete}${complete.includes('?') ? '&' : '?'}jwt=${encodeURIComponent(jeton)}`;
}
